import SupplierList from "./pages/ListPage.vue";
import SupplierDetail from "./pages/FormPage.vue";
import SupplierIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/supplier",
    component: SupplierIndex,
    redirect: "/supplier/list",
    name: "supplier",
    children: [
      {
        path: "list",
        component: SupplierList,
        name: "supplier.list",
      },
      {
        path: "create",
        component: SupplierDetail,
        name: "supplier.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: SupplierDetail,
        name: "supplier.edit",
        props: { create: false },
      },
    ],
  },
];
